import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 168,
	height: 168,
	viewBox: "0 0 168 168",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M39.4496 28.4164L76.2972 0L127.821 40.5948L91.5983 71.8216L115.331 91.8067L76.2972 128.03L21.6504 78.6915L60.9961 46.5279L39.4496 28.4164Z",
			fill: "#2699FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.2677 34.0372L46.3197 46.8402L14.7807 71.8216L0.416382 59.3309L32.2677 34.0372Z",
			fill: "#2699FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.628 46.5279L106.9 71.8216L122.513 85.2491L151.242 59.3309L135.628 46.5279Z",
			fill: "#2699FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.513 85.2491L115.019 130.84L139.375 107.732L150.929 59.3308L122.513 85.2491Z",
			fill: "#5EB2F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.331 91.8067L76.2973 127.717V168L109.398 136.149L115.331 91.8067Z",
			fill: "#5EB2F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.963 78.3792L30.7064 124.907L76.2975 168V127.718L21.963 78.3792Z",
			fill: "#2285DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7806 71.8215L0.728577 59.0186L12.907 108.045L24.7732 118.974L14.7806 71.8215Z",
			fill: "#2285DA"
		})
	]
});
export default SvgLogoIcon;
